// assets
import LockTwoToneIcon from '@mui/icons-material/LockTwoTone';
import LockOpenTwoToneIcon from '@mui/icons-material/LockOpenTwoTone';

export const state = {};

export const reducer = {};

export const gridActions = (row, permissionData, onClickActions) => {
    const gridActions = [];

    permissionData?.forEach((perm) => {
        switch (perm) {
            case 'canLock':
                if (row?.deletedAt || row?.locked) {
                    return;
                }

                gridActions.push({
                    key: `actionlock-row${row?.id}`,
                    icon: <LockTwoToneIcon fontSize="small" />,
                    label: 'ui-comp-button-lock',
                    position: 4,
                    showInMenu: true,
                    onClick: () => {
                        if ('onClickRowActionLock' in (onClickActions || {}) && typeof onClickActions.onClickRowActionLock === 'function') {
                            onClickActions.onClickRowActionLock(row);
                        }
                    }
                });
                break;
            case 'canUnlock':
                // if (row?.lockType === 'manual' && row?.lockedBy !== user['@id']) return;
                if (row?.deletedAt || !row?.locked) {
                    return;
                }

                gridActions.push({
                    key: `actionunlock-row${row?.id}`,
                    icon: <LockOpenTwoToneIcon fontSize="small" />,
                    label: 'ui-comp-button-unlock',
                    position: 5,
                    showInMenu: true,
                    onClick: () => {
                        if (
                            'onClickRowActionUnlock' in (onClickActions || {}) &&
                            typeof onClickActions.onClickRowActionUnlock === 'function'
                        ) {
                            onClickActions.onClickRowActionUnlock(row);
                        }
                    }
                });
                break;
            default: // do nothing
        }
    });

    return gridActions;
};
